import React, { useEffect, useRef, useState } from "react";
import "./verification.css";
import avatars from "../Global/avtar";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  KeyboardArrowDownSharp,
  KeyboardArrowUpSharp,
} from "@mui/icons-material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import PersonIcon from "@mui/icons-material/Person";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import {
  handleToast,
  isValidDecimalInput,
  isValidEmail,
  isValuePresent,
} from "../../utils";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { getLanguages } from "../../services/api/languages";
import { getExpertise } from "../../services/api/expertise";
import { 
  // handleStatus, 
  update_consultant } from "../../services/api/consultant";
import { createImage } from "../../services/api/Image";
import { getServices } from "../../services/api/services";
import { useNavigate } from "react-router-dom";
import ZoomOUT from "../Bank Account/Zoom";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Verification({ datas, edit2 }) {
  const navigate = useNavigate();
  const sk = datas.SK;
  const pk = datas.PK;
  const [name, setName] = useState(datas?.name || "");
  const [Conlanguage, setConLanguage] = useState(datas?.language_ids || []);
  const [age, setAge] = useState(datas?.age || "");
  const [hours, setHours] = useState(datas?.hours || "");
  const [education, setEducation] = useState(datas?.education || "");
  const [service, setService] = useState(datas?.service_id || "");
  const [expertise, setExpertise] = useState(datas?.expertise_ids || []);
  const [phonenumber, setPhonenumber] = useState(datas?.phone_number || "");
  const [email, setEmail] = useState(datas?.email || "");
  const [img, setImg] = useState(datas?.photo || "");
  const [photo1, setPhoto1] = useState(datas?.aadhar_card || "");
  const [photo2, setPhoto2] = useState(datas?.pan_card || "");
  const [up, setUp] = useState(false);
  const [down, setDown] = useState(false);
  const [languagedata, setLanguagedata] = useState([]);
  const [serv, setServ] = useState([]);
  const [expertdata, setExpertdata] = useState([]);
  const [imagediv, setImagediv] = useState(datas?.photo ? false : true);
  const [isupload5, setIsupload5] = useState(false);
  const [isupload6, setIsupload6] = useState(false);
  const [loader, setLoder] = useState(false);
  // eslint-disable-next-line
  const [IsTrue, setIstrue] = useState(true);
  const [objecturl4, setObjectURL4] = useState(datas?.aadhar_card || "");
  const [objecturl5, setObjectURL5] = useState(datas?.pan_card || "");
  const [mainCall, setMainCall] = useState(
    datas?.main_call_charges_per_minute || ""
  );
  const [call, setCall] = useState(datas?.call_charges_per_minute || "");
  const [chatCall, setChatcall] = useState(
    datas?.chat_charges_per_message || ""
  );
  // eslint-disable-next-line
  const [audioName, setAudioName] = useState([
    {
      created_at: "2025-03-17T06:39:34.408Z",
      deleted_at: null,
      deteted_at: null,
      name: "Profile_intro",
      updated_at: null,
      __v: 0,
      _id: "67d7c3a6fbb4419a2d86c37d",
    },
  ]);
  const [fileData, setFileData] = useState({
    Profile_intro: {
      file: {},
      url: datas?.intro_recording || "",
    },
  });
  const [isUpload, setIsUpload] = useState({
    Profile_intro: datas.intro_recording ? true : false,
  });
  const audioRefs = useRef({});
  const [uploadAudio, setIsUploadAudio] = useState("");
  const length = Object.keys(fileData).length;
  const namelength = audioName.length;
  const [isPhoto, setIsPhoto] = useState(datas.photo ? true : null);
  const [isNumber, setIsNumber] = useState(null);
  const isEmail = isValidEmail(email) ? true : null;
  const cleanedcall = isValidDecimalInput(call) ? true : null;
  const cleanedMaincall = isValidDecimalInput(mainCall) ? true : null;
  const cleanedcallChat = isValidDecimalInput(chatCall) ? true : null;
  const [face_verified, setface_verified] = useState(datas.face_verified);
  const requiredFields = [
    name,
    education,
    face_verified,
    isEmail,
    age,
    chatCall,
    cleanedcall,
    cleanedMaincall,
    cleanedcallChat,
    mainCall,
    call,
    isPhoto,
    isNumber,
    hours,
    Conlanguage,
    service,
    expertise,
    isupload5,
    isupload6,
    uploadAudio,
    email,
  ];
  // eslint-disable-next-line
  const [audioUpload, setAudioUpload] = useState(true);
  // eslint-disable-next-line
  const [data, setData] = useState(false);
  const englishLanguage = languagedata.find(
    (lang) => lang.name?.trim().toLowerCase() === "english"
  );
  // eslint-disable-next-line
  const selectedLanguages = languagedata.filter((lang) =>
    Conlanguage.includes(lang.id)
  );
  // eslint-disable-next-line
  const selectedExpertise = expertdata.filter((ser) =>
    expertise.includes(ser.id)
  );
  // eslint-disable-next-line
  const serviceData = serv.find((ser) => ser.id === service);
  // eslint-disable-next-line
  const englishId = englishLanguage?.id;
  const isMobile = window.innerWidth <= 600;
  // eslint-disable-next-line
  const [audio, setAudio] = useState(null);
  const [verification_image, setverification_image] = useState(
    datas?.verification_image || ""
  );
  const [objecturl6, setObjectURL6] = useState(datas?.verification_image || "");
  const [isupload7, setIsupload7] = useState(false);
  const audiofields = [photo1, photo2, verification_image];
  const object = [objecturl4, objecturl5, objecturl6];

  const [activeZoom, setActiveZoom] = useState(null);
  const consultant = true;

  const getLan = () => {
    getLanguages(null, "all")
      .then((response) => {
        if (response.data.status) {
          setLanguagedata(response?.data?.data?.data || []);
        }
      })
      .catch((error) => {
        handleToast(error);
        console.log(error.message);
      });
  };

  const getServ = () => {
    getServices(null, "all")
      .then((response) => {
        if (response.data.status) {
          setServ(response?.data?.data?.data || []);
        }
      })
      .catch((error) => {
        handleToast(error);
        console.log(error.message);
      });
  };

  const getExpet = () => {
    getExpertise(null, "all")
      .then((response) => {
        if (response.data.status) {
          setExpertdata(response?.data?.data?.data || []);
        }
      })
      .catch((error) => {
        handleToast(error);
        console.log(error.message);
      });
  };

  useEffect(() => {
    getLan();
    getExpet();
    getServ();
  }, []);

  useEffect(() => {
    const isAllFilled = requiredFields.some((field) => !isValuePresent(field));
    setIstrue(isAllFilled);
  }, [...requiredFields]);
  useEffect(() => {
    // setLoder(isAllFilleds)
  }, [data]);

  useEffect(() => {
    if (photo1) {
      setIsupload5(true);
    }
    if (photo2) {
      setIsupload6(true);
    }
    if (verification_image) {
      setIsupload7(true);
    }
  }, [...audiofields]);

  useEffect(() => {
    return () => {
      if (objecturl4) {
        URL.revokeObjectURL(objecturl4);
      }
      if (objecturl5) {
        URL.revokeObjectURL(objecturl5);
      }
    };
  }, [...object]);

  useEffect(() => {
    if (Object.keys(fileData).length !== 0) {
      if (length === namelength) {
        setIsUploadAudio(true);
      }
      object;
    }
  }, [fileData]);

  const handlePhoneNumber = (e) => {
    const newValue = e.target.value;
    const numstart = newValue.split("");
    if (newValue === "" || /^\d*$/.test(newValue)) {
      setPhonenumber(newValue);
      if (newValue.length === 10) {
        setIsNumber(true);
      } else {
        setIsNumber(false);
      }
    }
    if (numstart[0] < 5) {
      setPhonenumber("");
    }
  };

  const submit = (status, id, SK, PK, e) => {
    e.preventDefault();
    setLoder(true);
    // const form = new FormData();
    // const body = {
    //   status: status,
    //   id: id,
    //   face_verified: face_verified,
    // };
    // Object.keys(body).forEach((key) => {
    //   form.append(key, body[key]);
    // });
    const updatedData = {
      ...datas,
      // status: status,
      approve_status : status,
      id: id,
      face_verified: face_verified.toString(),
    };
    try {
      update_consultant(updatedData)
        .then(() => {
          navigate("/admin/consultant");
          toast.success("Profile Approved Successfully", {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoder(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      setLoder(false);
      return;
    }
  };

  const remove = (status, id, 
    // SK, PK
  ) => {
    setLoder(true);
    // const form = new FormData();
    // const body = {
    //   SK: SK,
    //   PK: PK,
    //   status: status,
    //   id: id,
    //   face_verified: face_verified,
    // };
    // Object.keys(body).forEach((key) => {
    //   form.append(key, body[key]);
    // });
    const updatedData = {
      ...datas,
      // status: status,
      approve_status : status,
      id: id,
      face_verified: face_verified.toString(),
    };
    try {
      update_consultant(updatedData)
        .then(() => {
          navigate("/admin/consultant");
          toast.error("Profile Rejected", {
            position: isMobile ? "top-left" : "top-center",
            style: {
              width: isMobile ? "300px" : "400px",
              textWrap: isMobile && "wrap",
            },
          });
        })
        .catch((error) => {
          handleToast(error?.response?.data);
          setLoder(false);
          return;
        });
    } catch (error) {
      handleToast(error?.response?.data);
      console.log(error);
      setLoder(false);
      return;
    }
  };

  const handleUploadFile = (data, type) => {
    if (!data) {
      return;
    }
    return createImage(data, type)
      .then((response) => {
        if (response.data.status === "success") {
          return response?.data?.data;
        }
      })
      .catch((error) => {
        handleToast(error?.response?.data);
        return;
      });
  };

  const handlePhoto5 = async (e) => {
    const file = e.target.files[0];
    setObjectURL4("");
    // setPhoto1(file)
    const form = new FormData();
    form.append("file", file);
    setIsupload5("false");
    const image = await handleUploadFile(form, "aadhar_card");
    setPhoto1(image);
    if (file) {
      if (objecturl4) {
        URL.revokeObjectURL(objecturl4);
      }
      const audioURL = URL.createObjectURL(file);
      setObjectURL4(audioURL);
    }
  };

  const handlePhoto6 = async (e) => {
    const file = e.target.files[0];
    setObjectURL5("");
    const form = new FormData();
    form.append("file", file);
    setIsupload6("false");
    const image = await handleUploadFile(form, "pan_card");
    setPhoto2(image);
    if (file) {
      if (objecturl5) {
        URL.revokeObjectURL(objecturl5);
      }
      const audioURL = URL.createObjectURL(file);
      setObjectURL5(audioURL);
    }
  };
  const handlePhoto7 = async (e) => {
    const file = e.target.files[0];
    setObjectURL6("");
    const form = new FormData();
    form.append("file", file);
    setIsupload7("false");
    const image = await handleUploadFile(form, "verification_image");
    setverification_image(image);
    if (file) {
      if (objecturl6) {
        URL.revokeObjectURL(objecturl6);
      }
      const audioURL = URL.createObjectURL(file);
      setObjectURL6(audioURL);
    }
  };

  const handleFileChange = async (field, event) => {
    const selectedFile = event.target.files[0];
    const form = new FormData();
    setIsUpload("false");
    form.append("file", selectedFile);
    const audio = await handleUploadFile(form, "profile_intro");
    setAudio(audio);
    setFileData((prev) => {
      if (prev[field]?.url) {
        URL.revokeObjectURL(prev[field].url);
      }
      const updatedData = {
        ...prev,
        [field]: selectedFile
          ? { file: selectedFile, url: URL.createObjectURL(selectedFile) }
          : null,
      };
      return updatedData;
    });

    setIsUpload((prev) => ({ ...prev, [field]: !!selectedFile }));
    // Reload audio if exists
    if (audioRefs.current[field]) {
      audioRefs.current[field].load();
    }
  };

  const handleDropdown = () => {
    setDown((prev) => !prev);
    setUp((prev) => !prev);
  };

  const handleCallcharge = (e) => {
    let input = e.target.value;

    // Remove invalid characters (only digits and one dot allowed)
    input = input.replace(/[^0-9.]/g, "");

    // Prevent more than one dot
    const parts = input.split(".");
    if (parts.length > 2) {
      input = parts[0] + "." + parts.slice(1).join("");
    }
    setCall(input);
  };

  const handleChatcall = (e) => {
    let input = e.target.value;

    // Remove invalid characters (only digits and one dot allowed)
    input = input.replace(/[^0-9.]/g, "");

    // Prevent more than one dot
    const parts = input.split(".");
    if (parts.length > 2) {
      input = parts[0] + "." + parts.slice(1).join("");
    }

    setChatcall(input);
  };

  const handleMaincall = (e) => {
    let input = e.target.value;

    // Remove invalid characters (only digits and one dot allowed)
    input = input.replace(/[^0-9.]/g, "");

    // Prevent more than one dot
    const parts = input.split(".");
    if (parts.length > 2) {
      input = parts[0] + "." + parts.slice(1).join("");
    }

    setMainCall(input);
  };

  const handlestate = (e) => {
    e.preventDefault();
    setface_verified(e.target.value);
  };

  return (
    <>
      <div className="form">
        {!loader ? (
          <div className="form">
            <form
              onSubmit={(e) => {
                submit("Approved", datas.id, sk, pk, e);
              }}
            >
              <div className="input-type">
                <h3>
                  Name <sup>*</sup>
                </h3>
                <input
                  type="text"
                  placeholder="Enter Name"
                  required
                  value={name}
                  id="first-name"
                  name="firstname"
                  autoComplete="firstname"
                  disabled={edit2}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (/^[A-Za-z\s]*$/.test(newValue)) {
                      setName(newValue);
                    }
                  }}
                />
              </div>
              <div className="location">
                <h3> Consultant Language</h3>
                <div className="field">
                  <div className="subfield" style={{ width: "100%" }}>
                    <FormControl>
                      <label htmlFor="Choose conversation languages">
                        <h3>
                          Choose conversation languages <sup>*</sup>
                        </h3>
                      </label>
                      <Select
                        multiple
                        required
                        className="selec"
                        displayEmpty
                        disabled={edit2}
                        value={Conlanguage}
                        onChange={(e) => {
                          setConLanguage(e.target.value);
                        }}
                        renderValue={(select) => {
                          if (select.length === 0) {
                            return "Choose conversation language";
                          }

                          const selectedLanguages = languagedata
                            .filter((data) => select.includes(data.id))
                            .map((data) => data.name)
                            .join(",");

                          return selectedLanguages;
                        }}
                        MenuProps={MenuProps}
                        style={{
                          background: "white",
                          boxShadow: "none",
                          border: "0.9px solid #1c1c1c1f",
                          borderRadius: "5px",
                          color: "#1c1c1cc8",
                          width: "100%",
                        }}
                      >
                        {languagedata.map((name) => (
                          <MenuItem key={name} value={name.id}>
                            <Checkbox checked={Conlanguage.includes(name.id)} />
                            <ListItemText primary={name.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="UserDetails">
                <h3> Consultant Charges</h3>
                <div className="field">
                  <div className="subfield1">
                    <label htmlFor="Select age group">
                      {" "}
                      <h6>
                        Call Charges Per Minute<sup>*</sup>
                      </h6>
                    </label>
                    <input
                      type="tel"
                      className="user-select"
                      value={call}
                      disabled={edit2}
                      placeholder="Enter Call Charge"
                      onChange={handleCallcharge}
                    />
                  </div>

                  <div className="subfield1">
                    <label htmlFor="Select Hours">
                      <h6>
                        Chat Charges Per Message <sup>*</sup>
                      </h6>
                    </label>
                    <input
                      type="tel"
                      className="user-select"
                      value={chatCall}
                      disabled={edit2}
                      placeholder="Enter Chat Charge"
                      onChange={handleChatcall}
                    />
                  </div>
                  <div className="subfield1">
                    <label htmlFor="Select highest education"></label>{" "}
                    <h6>
                      Main Call Charges Per Minute <sup>*</sup>
                    </h6>
                    <input
                      type="tel"
                      className="user-select"
                      value={mainCall}
                      disabled={edit2}
                      placeholder="Enter Main Call Charge"
                      onChange={handleMaincall}
                    />
                  </div>
                </div>
              </div>
              <div className="UserDetails">
                <h3>Consultant Details</h3>
                <div className="field">
                  <div className="subfield1">
                    <label htmlFor="Select age group">
                      {" "}
                      <h3>
                        Select age group <sup>*</sup>
                      </h3>
                    </label>
                    <Select
                      name="age group"
                      className="user-select"
                      value={age}
                      onChange={(e) => {
                        setAge(e.target.value);
                      }}
                      required
                      id="app-language"
                      autoComplete="AgeGroup"
                      displayEmpty
                      style={{
                        background: "white",
                        boxShadow: "none",
                        border: "0.9px solid #1c1c1c1f",
                        borderRadius: "5px",
                        color: "#1c1c1cc8",
                      }}
                      inputProps={{ "aria-label": "Without label" }}
                      disabled={edit2}
                    >
                      <MenuItem value="" disabled>
                        Select age group
                      </MenuItem>
                      <MenuItem value="Below 18">Below 18</MenuItem>
                      <MenuItem value="18-24">18-24</MenuItem>
                      <MenuItem value="25-35">25-35</MenuItem>
                      <MenuItem value="Above 35">Above 35</MenuItem>
                    </Select>
                  </div>

                  <div className="subfield1">
                    <label htmlFor="Select Hours">
                      <h3>
                        Select Hours <sup>*</sup>
                      </h3>
                    </label>
                    <Select
                      name="Choose app Language"
                      className="user-select"
                      value={hours}
                      onChange={(e) => {
                        setHours(e.target.value);
                      }}
                      required
                      id="app-language"
                      autoComplete="Hours"
                      displayEmpty
                      style={{
                        background: "white",
                        boxShadow: "none",
                        border: "0.9px solid #1c1c1c1f",
                        borderRadius: "5px",
                        color: "#1c1c1cc8",
                      }}
                      disabled={edit2}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="" disabled>
                        Select Hours
                      </MenuItem>
                      <MenuItem value="4">4hrs</MenuItem>
                      <MenuItem value="8">8hrs</MenuItem>
                      <MenuItem value="10">10hrs</MenuItem>
                    </Select>
                  </div>
                  <div className="subfield1">
                    <label htmlFor="Select highest education"></label>{" "}
                    <h3>
                      Select highest education <sup>*</sup>
                    </h3>
                    <Select
                      name="Select highest education"
                      className="user-select"
                      displayEmpty
                      value={education}
                      onChange={(e) => {
                        setEducation(e.target.value);
                      }}
                      required
                      id="Highest-Education"
                      autoComplete="Highesteducation"
                      style={{
                        background: "white",
                        boxShadow: "none",
                        border: "0.9px solid #1c1c1c1f",
                        borderRadius: "5px",
                        color: "#1c1c1cc8",
                      }}
                      disabled={edit2}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value="" disabled>
                        Select highest education
                      </MenuItem>
                      <MenuItem value="Matriculation">10th pass</MenuItem>
                      <MenuItem value="Intermediate">12th pass</MenuItem>
                      <MenuItem value="Bachelor Degree">
                        Bachelor Degree
                      </MenuItem>
                      <MenuItem value="Master Degree">Master Degree</MenuItem>
                      <MenuItem value="other">Other</MenuItem>
                    </Select>
                  </div>
                </div>
              </div>
              <div className="dateofbirth">
                <h3>Consultant Service</h3>
                <div className="field">
                  <div className="subfield">
                    <label htmlFor="serivce">
                      {" "}
                      <h3>
                        Service <sup>*</sup>
                      </h3>
                    </label>
                    <Select
                      name="service"
                      value={service}
                      disabled={edit2}
                      onChange={(e) => {
                        setService(e.target.value);
                      }}
                      required
                      id="service"
                      autoComplete="Service"
                      displayEmpty
                      className="userservice"
                      style={{
                        background: "white",
                        boxShadow: "none",
                        border: "0.9px solid #1c1c1c1f",
                        borderRadius: "5px",
                        color: "#1c1c1cc8",
                      }}
                      renderValue={(select) => {
                        if (select.length === 0) {
                          return "Choose Service";
                        }
                        const selectedLanguages = serv
                          .filter((data) => select.includes(data.id))
                          .map((data) => data.name);

                        return selectedLanguages;
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select Service
                      </MenuItem>
                      {serv.map((data, e) => {
                        return (
                          <MenuItem value={data.id} key={e}>
                            {data.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="subfield">
                    <FormControl>
                      <label htmlFor="Select expertise">
                        <h3>
                          Select expertise <sup>*</sup>
                        </h3>
                      </label>
                      <Select
                        multiple
                        required
                        disabled={edit2}
                        className="userservice"
                        displayEmpty
                        value={expertise}
                        onChange={(e) => {
                          setExpertise(e.target.value);
                        }}
                        renderValue={(select) => {
                          if (select.length === 0) {
                            return "Select expertise";
                          }

                          const selectedExpertise = expertdata
                            .filter((data) => select.includes(data.id))
                            .map((data) => data.name)
                            .join(",");

                          return selectedExpertise;
                        }}
                        MenuProps={MenuProps}
                        style={{
                          background: "white",
                          boxShadow: "none",
                          border: "0.9px solid #1c1c1c1f",
                          borderRadius: "5px",
                          color: "#1c1c1cc8",
                          overflow: "none",
                          width: "400px",
                        }}
                      >
                        {expertdata.map((data) => (
                          <MenuItem key={data} value={data.id}>
                            <Checkbox checked={expertise.includes(data.id)} />
                            <ListItemText primary={data.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="input-type">
                <h3>Phone Number</h3>
                <input
                  type="tel"
                  placeholder="Enter Phonenumber"
                  value={phonenumber}
                  onChange={handlePhoneNumber}
                  disabled={edit2}
                  maxLength="10"
                  id="PhoneNumber"
                  name="Phonenumber"
                  autoComplete="PhoneNumber"
                />
              </div>
              <div className="input-type">
                <h3>
                  Email <sup>*</sup>
                </h3>
                <input
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  disabled={edit2}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  required
                  id="Email"
                  name="Email"
                  autoComplete="Email"
                />
              </div>
              <div>
                <label htmlFor="Is Default">
                  <h4>Face Verified</h4>
                </label>
                <Select
                  className="data-select"
                  style={{
                    background: "white",
                    width: "100%",
                    height: "45px",
                    border: "0.8px solid #1c1c1c1f",
                    borderRadius: "10px",
                    color: "rgba(28, 28, 28, 0.56)",
                  }}
                  onChange={handlestate}
                  value={face_verified}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  required
                >
                  <MenuItem value="" disabled>
                    Select Type
                  </MenuItem>
                  <MenuItem value={true}>True</MenuItem>
                  <MenuItem value={false}>False</MenuItem>
                </Select>
              </div>
              <div className="input-photo">
                <h2>Upload Documents</h2>
                <div className="field-photo">
                  <div className="subfield">
                    <label htmlFor="Select Aadhar Card">
                      <h3>
                        Select Aadhar Card <sup>*</sup>
                      </h3>{" "}
                    </label>
                    <Button
                      component="label"
                      role={undefined}
                      disabled={edit2}
                      variant="contained"
                      tabIndex={-1}
                      startIcon={<CloudUploadIcon />}
                      className="buttonu"
                      style={{ width: "370px" }}
                    >
                      {isupload5 === true
                        ? "Uploaded"
                        : isupload5 === false
                          ? "Upload"
                          : "Uploading..."}
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handlePhoto5}
                        multiple
                        accept="image/*"
                        id="Aadhar Card"
                        name="Aadhar Card"
                        autoComplete="Aadhar Card"
                      />
                    </Button>
                    {isupload5 && (
                      <div className="image-box">
                        <ZoomOUT
                          imageUrl={objecturl4 || ""}
                          key={objecturl4 || ""}
                          zoomKey={objecturl4 || ""}
                          activeZoom={activeZoom}
                          setActiveZoom={setActiveZoom}
                          consultant={false}
                        />
                      </div>
                    )}
                  </div>
                  <div className="subfield">
                    <label htmlFor="Select Pan Card">
                      <h3>
                        Select Pan Card <sup>*</sup>
                      </h3>
                    </label>
                    <Button
                      component="label"
                      role={undefined}
                      disabled={edit2}
                      variant="contained"
                      tabIndex={-1}
                      startIcon={<CloudUploadIcon />}
                      className="buttonu"
                      style={{
                        width: "370px",
                      }}
                    >
                      {isupload6 === true
                        ? "Uploaded"
                        : isupload6 === false
                          ? "Upload"
                          : "Uploading..."}
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handlePhoto6}
                        multiple
                        accept="image/*"
                        id="Pan Card"
                        name="Pan Card"
                        autoComplete="Pan Card"
                      />{" "}
                    </Button>
                    {isupload6 && (
                      <div className="image-box">
                        <ZoomOUT
                          imageUrl={objecturl5 || ""}
                          key={objecturl5 || ""}
                          zoomKey={objecturl5 || ""}
                          activeZoom={activeZoom}
                          setActiveZoom={setActiveZoom}
                          consultant={false}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="subfield"
                  style={{
                    paddingTop: "12px",
                  }}
                >
                  <label htmlFor="Select Verification Image">
                    <h3>
                      Select Verification Image <sup>*</sup>
                    </h3>
                  </label>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    disabled={edit2}
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                    className="buttonu"
                    style={{
                      width: "370px",
                    }}
                  >
                    {isupload7 === true
                      ? "Uploaded"
                      : isupload7 === false
                        ? "Upload"
                        : "Uploading..."}
                    <VisuallyHiddenInput
                      type="file"
                      onChange={handlePhoto7}
                      multiple
                      accept="image/*"
                      id="Pan Card"
                      name="Pan Card"
                      autoComplete="Pan Card"
                    />
                  </Button>
                  {isupload7 && (
                    <div className="image-box">
                      <ZoomOUT
                        imageUrl={objecturl6 || ""}
                        key={objecturl6 || ""}
                        zoomKey={objecturl6 || ""}
                        activeZoom={activeZoom}
                        setActiveZoom={setActiveZoom}
                        consultant={false}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="input-audio" style={{ marginTop: "10px" }}>
                <h2>Upload Audio</h2>
                {audioUpload ? (
                  <div className="field audiofile">
                    {audioName.map((elt) => (
                      <div key={elt.name} className="subfield-audio">
                        <label htmlFor={elt.name}>
                          {elt.name.replace(/_/g, " ")}{" "}
                          <sup style={{ color: "red" }}>*</sup>
                        </label>
                        <Button
                          component="label"
                          disabled={edit2}
                          name={elt.name}
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                          className="buttonu"
                          style={{ background: "#F99923", width: "100%" }}
                          required
                        >
                          {isUpload[elt.name] === true
                            ? "Uploaded"
                            : isUpload[elt.name] === false
                              ? "Upload"
                              : "Uploading..."}
                          {/* {isUpload[elt.name] ? "Uploaded" : "Upload"} */}
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(e) => handleFileChange(elt.name, e)}
                            accept="audio/*"
                            id={elt.name}
                            autoComplete={elt.name}
                          />
                        </Button>
                        {fileData[elt.name]?.url && (
                          <audio
                            controls
                            style={{ marginTop: "10px", width: "100%" }}
                            ref={(el) => (audioRefs.current[elt?.name] = el)}
                          >
                            <source
                              src={fileData[elt.name].url}
                              type={fileData[elt.name].file.type}
                            />
                            Your browser does not support the audio element.
                          </audio>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="loader-2">
                    <CircularProgress
                      style={{ color: "var(--admin-page--color)" }}
                    />
                  </div>
                )}
              </div>
              <div className="submit-create">
                <button
                  className="btn1"
                  onClick={() => {
                    remove("Rejected", datas.id, sk, pk);
                  }}
                  style={{
                    outline: face_verified
                      ? "1px solid var(--admin-page--color)"
                      : " 1px solid var(--admin-page--color)",
                    color: face_verified
                      ? "var(--admin-page--color)"
                      : "var(--admin-page--color)",
                    background: face_verified ? "#FFFFFF" : "#FFFFFF",
                    cursor: face_verified ? "pointer" : "pointer",
                  }}
                  disabled={false}
                >
                  Reject
                </button>
                <button
                  className="btn2"
                  style={{
                    outline: !face_verified
                      ? "none"
                      : " 1px solid var(--admin-page--color)",
                    color: !face_verified ? "#1c1c1c6d" : "#ffffff",
                    background: !face_verified
                      ? "rgba(63, 61, 61, 0.07)"
                      : " var(--admin-page--color)",
                    cursor: !face_verified ? "not-allowed" : "pointer",
                  }}
                  disabled={!face_verified ? true : false}
                >
                  Approve
                </button>
              </div>
            </form>
            <div className="imagcont">
              <div className="imagecontainer">
                {imagediv ? (
                  <div className="img-div">
                    <PersonIcon style={{ height: "300px", width: "100%" }} />
                  </div>
                ) : (
                  <div className="img">
                    <ZoomOUT
                      imageUrl={img || ""}
                      key={data?._id || ""}
                      zoomKey={data?._id || ""}
                      activeZoom={activeZoom}
                      setActiveZoom={setActiveZoom}
                      consultant={consultant}
                    />
                  </div>
                )}
                <label htmlFor="avtar">
                  <button
                    onClick={handleDropdown}
                    style={{ marginRight: "30px" }}
                    disabled={edit2}
                  >
                    <h3>Select Avatar</h3>
                    {up === false ? (
                      <KeyboardArrowDownSharp />
                    ) : (
                      <KeyboardArrowUpSharp />
                    )}
                  </button>
                </label>
                <hr />
              </div>
              {down ? (
                <div className="imgbox">
                  {avatars.map((avatar, x) => {
                    return (
                      <img
                        src={avatar.image}
                        key={x}
                        style={{
                          borderRadius: "30px",
                        }}
                        alt=""
                        onClick={() => {
                          setImg(avatar.image);
                          setIsPhoto(true);
                          setImagediv(false);
                        }}
                      />
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="loader">
            <CircularProgress style={{ color: "var(--admin-page--color)" }} />
          </div>
        )}
      </div>
    </>
  );
}
